import React, { useMemo } from 'react';
import { LocalConfig } from 'utils';

import { constants, getMaintenanceByMode } from '@atlas/core';
import { Maintenance } from '@atlas/ui';

import Logo from 'common/Widgets/Logo/Logo';

const {
  MAINTENANCE_MODE: { GLOBAL },
} = constants;

const GlobalMaintenanceContainer = ({ children }) => {
  const projectId = LocalConfig.get('projectId');
  const maintenance = useMemo(() => getMaintenanceByMode(GLOBAL, projectId), [projectId]);

  if (maintenance) {
    return <Maintenance endAt={maintenance.end_at} logo={<Logo />} type={GLOBAL} />;
  }

  return children;
};

export default GlobalMaintenanceContainer;
